import { FileText, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Nota de incidencia (teclado) asociada al ticket del valet (presentacional puro).
export const NotaIncidenciaModal = ({ notaTarget, setNotaTarget, notaTexto, setNotaTexto, guardarNota, notaSaving }) => (
  <Dialog open={!!notaTarget} onOpenChange={(o) => { if (!o) { setNotaTarget(null); setNotaTexto(""); } }}>
    <DialogContent className="rounded-none border-[#38BDF8]/40 bg-[#0A0A0A] text-white max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="valet-nota-modal">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white text-lg flex items-center gap-2"><FileText className="h-5 w-5 text-[#38BDF8]" /> Nota de Incidencia</DialogTitle>
        <DialogDescription className="text-white/50">{notaTarget ? `Folio ${notaTarget.folio_impreso}${notaTarget.placa ? " · " + notaTarget.placa : ""}` : ""}</DialogDescription>
      </DialogHeader>
      <textarea value={notaTexto} onChange={(e) => setNotaTexto(e.target.value)} data-testid="valet-nota-textarea"
        rows={5} autoFocus placeholder="Escribe la incidencia (ej. rayón previo, cliente molesto, objeto olvidado)..."
        className="w-full bg-white/5 border border-white/15 p-3 text-sm text-white placeholder:text-white/30 focus:border-[#38BDF8] outline-none resize-none" />
      <div className="flex gap-2 pt-1">
        <button onClick={() => { setNotaTarget(null); setNotaTexto(""); }} data-testid="valet-nota-cancelar"
          className="btn-hard flex-1 h-11 bg-white/5 border border-white/20 text-white/70 font-bold uppercase tracking-wider hover:bg-white/10">Cancelar</button>
        <button onClick={guardarNota} disabled={notaSaving} data-testid="valet-nota-guardar"
          className="btn-hard flex-1 h-11 bg-[#38BDF8] text-[#0A0A0A] border border-[#38BDF8] font-black uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-50">
          {notaSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Guardar Nota"}
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default NotaIncidenciaModal;
